// Any config specific to JORDAN?

export default {
  code: 'JO',
  countryName: 'Jordan',
  googleSiteVerificationCode: [
    'coMku_T76pvPnCq5Ujko01Lhfr_6LG7iH3moDYIpJ0E',
    'ZKT4WfzMzwCRBbnfvdEiQiZtLHCP9HXUknMh8bkbN7k',
    '23S8AoVEPAjiFC1DAmfd7StNRJE5wAf_kK11Pmth2eQ'
  ],
  countryDomain: 'https://www.carrefourjordan.com',
  helplineNumber: '962-6-5000015',
  latitude: 31.9804777,
  longitude: 35.8354861,
  countryFlagIcon: 'JO_17e24fa030.png',
  defaultAreaCode: 'Khalda - Amman',
  features: {
    languageChange: true,
    now: false,
    share: false,
    isLocationCXEnable: false,
    cashback: false,
    linkMyClubCard: false,
    oneTrustScript: '3373c30d-745c-4229-94ff-ea5fab9f8737'
  }
}
